import { Api } from "./Api.class";
const endpoint = "recruiter/campaigns";
const recruiterCampaignsAPI = new Api(endpoint);
export default recruiterCampaignsAPI;
